module.exports = __webpack_public_path__ + "img/smartphone-with-a-smile.a16abb2a.svg";